export default function roomNoticeEventListener(room) {
    return store => {
        room.addEventListeners({
            room_notice_init: e => {
                store.commit('notice/NOTICE_INIT', e.data)
            },
            room_notice_add: e => {
                store.commit('notice/ADD_NOTICE', e.data?.roomNotice)
                store.commit('notice/SET_NOTICE_FIX', e.data?.roomNotice)
            },
            room_notice_delete: e => {
                store.commit('notice/DELETE_NOTICE', e.data)
            },
            room_notice_fix: e => {
                store.commit('notice/SET_NOTICE_FIX', e.data)
            },
        })
    }
}